import React, { createContext } from 'react';
import { useParams } from 'react-router';

// Hooks
import { useReviewTemplate } from 'Shared/utils/hooks/use-review-template';

// Types
import { ReviewTemplateType } from 'Shared/types/ReviewTemplates.type';

export const ReviewTemplateContext = createContext<ReviewTemplateType | null>(null);

const ReviewTemplateProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { slug } = useParams();
  const { template } = useReviewTemplate({
    slug,
  });
  return <ReviewTemplateContext.Provider value={template}>{children}</ReviewTemplateContext.Provider>;
};

export default ReviewTemplateProvider;
